import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import LeadApi from '../../apis/lead';
import { PushLeadToPipelineParams } from '../../params/redux/leads';
import { resettingLeadLoader } from '../../redux/slices/leads';
import { RootState } from '../../redux/store';
import { fetchFormsThunk } from './form';

export const fetchLeadsThunk = createAsyncThunk(
    'lead/fetch',
    async (client_id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await LeadApi.fetchLeads(state.app.token, client_id);
            if (response?.success === 1) {
                return response?.data;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingLeadLoader());
        }
    }
);

export const saveMappingLeadsThunk = createAsyncThunk(
    'lead/save-mapping',
    async ({ data, client_id }: { data: Record<string, unknown>, client_id: number }, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await LeadApi.saveMappingLeads(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(fetchLeadsThunk(client_id)).unwrap();
                await dispatch(fetchFormsThunk(client_id)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingLeadLoader());
        }
    }
);

export const fetchHotLeadsThunk = createAsyncThunk(
    'lead/fetch-hot',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await LeadApi.fetchHotLeads(state.app.token);
            if (response?.success === 1) {
                return response?.hot_leads;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingLeadLoader());
        }
    }
);

export const pushLeadsToPipelineThunk = createAsyncThunk(
    'lead/push',
    async (data: PushLeadToPipelineParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await LeadApi.pushLeadToPipeline(state.app.token, data);
            if (response?.success === 1) {
                return response?.data;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingLeadLoader());
        }
    }
);

export const deleteLeadsThunk = createAsyncThunk(
    'lead/delete',
    async ({ ids, client_id }: { ids: number[], client_id: number }, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await LeadApi.deleteLead(state.app.token, ids);
            if (response?.success === 1) {
                await dispatch(fetchLeadsThunk(client_id)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingLeadLoader());
        }
    }
);